import React, { Component } from "react";
import { connect } from "react-redux";
class Col extends Component {
  render = () => (
    <div
      className={`${
        this.props.screen.mq === "l"
          ? `col-${this.props.l}`
          : this.props.screen.mq === "m"
          ? `col-${this.props.m ? `${this.props.m} m` : this.props.l}`
          : this.props.screen.mq === "s"
          ? `col-${
              this.props.s
                ? `${this.props.s} s`
                : this.props.m
                ? `${this.props.m} m`
                : this.props.l
            }`
          : this.props.screen.mq === "xs"
          ? `col-${
              this.props.xs
                ? `${this.props.xs} xs`
                : this.props.s
                ? `${this.props.s} s`
                : this.props.m
                ? `${this.props.m} m`
                : this.props.l
            }`
          : ""
      } ${this.props.className}`}
    >
      {this.props.children}
    </div>
  );
}
const mapStateToProps = state => ({
  screen: state.screen
});
export default connect(mapStateToProps)(Col);
